import { render, staticRenderFns } from "./TrendFollowing.vue?vue&type=template&id=75115ce9&scoped=true&"
import script from "./TrendFollowing.vue?vue&type=script&lang=js&"
export * from "./TrendFollowing.vue?vue&type=script&lang=js&"
import style0 from "./TrendFollowing.vue?vue&type=style&index=0&id=75115ce9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75115ce9",
  null
  
)

export default component.exports